import script from "./WithdrawalRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawalRequest.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawalRequest.vue?vue&type=style&index=0&id=c7cb229a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7cb229a"]])

export default __exports__